<template>
  <div class="c-checkBox">
    <input
      v-bind="{ ...$attrs, onChange: updateValue }"
      :id="uuid"
      :checked="modelValue"
      type="checkbox"
      class="c-checkBox__field"
    />

    <label class="c-checkBox__label" :for="uuid">
      <span>
        <slot />
      </span>
    </label>
    <p v-if="error" :id="`${uuid}-error`" class="c-checkBox__error">
      {{ error }}
    </p>
  </div>
</template>

<script>
import UniqueID from "@/utils/UniqueID";
import SetupFormComponent from "@/utils/SetupFormComponent";
export default {
  name: "CheckboxBase",
  props: {
    modelValue: {
      type: Boolean,
    },
    error: {
      type: String,
      default: "",
    },
  },
  setup(props, context) {
    const uuid = UniqueID().getID();
    const { updateValue } = SetupFormComponent(props, context);
    return {
      updateValue,
      uuid,
    };
  },
};
</script>

<style lang="scss">
.c-checkBox {
  &__field {
    display: none;

    &:checked + label {
      &::before {
        background-color: #2a6ae3;
        border-color: #2a6ae3;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 16px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 0 24 24' width='24px' fill='%23ffffff'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'/%3E%3C/svg%3E");
      }
    }
  }

  &__label {
    position: relative;
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    user-select: none;
    color: #65687e;

    span {
      margin-top: 0px;
      cursor: pointer;
    }

    a {
      font-weight: 600;
    }

    padding-right: 28px;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      width: 20px;
      height: 20px;
      border-radius: 4px;
      border: 1px solid #707070;
      cursor: pointer;
      right: 0;
    }
  }
}
</style>
